import { MainCard } from "../../../components/Card/Cards";
import { CustomTextArea } from "../../../components/Input/input";
import React, { useRef, useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { API_BASE_URL } from "../../../utils/constants";
import axios from "axios";
export default function Questionnaire({ step, setStep }) {
  const toast = useRef(null);
  const [questions, setQuestions] = useState([
    {
      id: 1,
      question: "Why did you leave your Previous Job?",
      type: "text",
      answer: "",
    },
    {
      id: 2,
      question: "Why do you want to join Shah Transport?",
      type: "text",
      answer: "",
    },
    {
      id: 3,
      question: "How did you hear about Shah Transport?",
      type: "text",
      answer: "",
    },
    {
      id: 4,
      question: "How long have you been driving a CMV in Canada / USA?",
      type: "text",
      answer: "",
    },
    {
      id: 5,
      question:
        "How do you respond when a dispatcher is pushing you to keep going when you're out of hours or tired? ",
      type: "text",
      answer: "",
    },
    {
      id: 6,
      question:
        "Have you ever been pulled over by M.O.T or D.O.T.? Was that a roadside or a Scale inspection? ",
      type: "text",
      answer: "",
    },
    {
      id: 7,
      question: "Have you ever been placed OUT OF SERVCE, if so, why?",
      type: "text",
      answer: "",
    },
    {
      id: 8,
      question: "Are you familiar or have you used with ELD?",
      type: "boolean",
      answer: false,
    },
    {
      id: 9,
      question: "Do you understand HOS in Canada & USA?",
      type: "boolean",
      answer: false,
    },
    {
      id: 10,
      question: "Have you ever moved Trailer Tandems / back axels?",
      type: "boolean",
      answer: false,
    },
    {
      id: 11,
      question:
        "Have you ever had any issues with any Customer or Dispatcher? If so, how did you handle that? ",
      type: "text",
      answer: "",
    },
    {
      id: 12,
      question:
        "Have you ever driven a commercial vehicle in adverse weather (Snow, Icy/ Rainy conditions/ heavy fog)? ",
      type: "text",
      answer: "",
    },
  ]);

  const handleChange = ({ name, value, index }) => {
    setQuestions((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, [name]: value } : item))
    );
  };

  const submitData = async () => {
    let error = questions.find((question) => question.answer === "");
    if (!error) {
      try {
        const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage

        console.log("token", token);
        const response = await axios.post(
          API_BASE_URL + "/api/driver/interview-questions",
          { questions: questions, authToken: token },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );
        console.log(response);
        setStep((prev) => prev + 1);
      } catch (err) {
        alert(err.response?.data?.message || "Failed to save information");
      }
    } else
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "All Answers required",
      });
  };

  return (
    <MainCard size="container">
      <Toast ref={toast} />
      {questions?.map((obj, index) => (
        <>
          <p className="font-semibold">
            <span className="mr-3">{obj?.id}.</span>
            {obj?.question}
          </p>
          {obj?.type === "text" ? (
            <div className="pl-4">
              <CustomTextArea
                name="answer"
                value={obj?.answer}
                onChange={({ name, value }) =>
                  handleChange({ name, value, index })
                }
              />
            </div>
          ) : (
            <div className="flex align-items-center gap-3 pl-5">
              <span className={!obj?.answer ? "font-semibold" : ""}>No</span>
              <InputSwitch
                checked={obj?.answer}
                onChange={(e) =>
                  setQuestions((prev) =>
                    prev?.map((item) =>
                      item?.id === obj?.id
                        ? { ...item, answer: e?.value }
                        : item
                    )
                  )
                }
              />
              <span className={obj?.answer ? "font-semibold" : ""}>Yes</span>
            </div>
          )}
        </>
      ))}
      <div className="flex justify-content-end mt-4 pr-2">
        <Button label="Save & Continue" onClick={submitData} />
      </div>
    </MainCard>
  );
}
